"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const networks_1 = require("./configs/networks");
const utils_1 = require("./utils");
const ekc_pca_1 = __importDefault(require("./ekc-pca"));
const ekc_proxy_1 = __importDefault(require("./ekc-proxy"));
const ekc_signer_1 = __importDefault(require("./ekc-signer"));
const ekc_provider_1 = __importDefault(require("./ekc-provider"));
class EnterpriseKeyConnect {
    constructor(pcaAuthOptions, pcaScopes = [], proxyURL = '', network) {
        this.pca = new ekc_pca_1.default(pcaAuthOptions, pcaScopes);
        this.proxy = new ekc_proxy_1.default(proxyURL).bindTo(this);
        this.provider = new ekc_provider_1.default(network);
        this.signer = new ekc_signer_1.default(this.provider).bindTo(this);
    }
    static init({ proxyUrl, network = networks_1.Networks.VOLTA, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!EnterpriseKeyConnect.instance) {
                const { authOptions, scopes } = yield (0, utils_1.fetchAPI)(proxyUrl + '/config/client');
                EnterpriseKeyConnect.instance = new EnterpriseKeyConnect(authOptions, scopes, proxyUrl, network);
            }
            const _this = EnterpriseKeyConnect.instance;
            return _this;
        });
    }
    /* **************************************************************************** */
    login(request) {
        return this.pca.login(request);
    }
    logout(request) {
        return this.pca.logout(request);
    }
    getAccount() {
        return this.pca.getAccount();
    }
    getAddress() {
        return this.proxy.getAddress();
    }
    /* **************************************************************************** */
    getSigner() {
        return this.signer;
    }
    signMessage(message) {
        return this.signer.signMessage(message);
    }
    verifyMessage(message, signature) {
        return this.signer.verifyMessage(message, signature);
    }
    sendTransaction(transaction) {
        return this.signer.sendTransaction(transaction);
    }
    /* **************************************************************************** */
    getNetwork() {
        return this.provider.networkEnum;
    }
    setNetwork(network) {
        this.provider = new ekc_provider_1.default(network);
        this.signer = new ekc_signer_1.default(this.provider).bindTo(this);
        return;
    }
    /* **************************************************************************** */
    _getProvider() {
        return this.provider;
    }
    _getProxy() {
        return this.proxy;
    }
    _getPCA() {
        return this.pca;
    }
}
exports.default = EnterpriseKeyConnect;
